import {
  GET_OPPORTUNITIES,
  GET_INFORMATION,
  SET_CARD,
} from "../actions/types";

const initialState = {
  information: null,
  opportunities: [],
  averageYieldPercentage: 0,
  selectedCard: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_OPPORTUNITIES:
      return {
        ...state,
        opportunities: action.payload.opportunities || action.payload,
        averageYieldPercentage: action.payload.averageYieldPercentage || 0,
      };
    case GET_INFORMATION:
      return {
        ...state,
        information: action.payload,
      };
    case SET_CARD:
      return {
        ...state,
        selectedCard: action.payload,
      };
    default:
      return state;
  }
}
